<template>
    <div id="EffectiveCPIRateCreate" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="effectiveCPIRateHeader" v-if="$route.params.id > 0">Update Effective CPI Rate</span>
                    <span class="page-title" id="effectiveCPIRateHeader" v-else>Add Effective CPI Rate</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackEffectiveCPIRateList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="EffectiveCPIRateForm">
                                <div class="form-row row-cols-md-4 row-col-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="cpi_code">CPI Code:</label>
                                        <v-select v-model="cpi_code" name="cpi_code" id="cpi_code"
                                            label="text" :filterable="false" :options="cpicodeArr"
                                            placeholder="Select CPI Code" class="custom-ci-auto-search">
                                        </v-select>
                                        <div class="field-error">{{ cpi_code_err_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="base_value">Base Value:</label>
                                        <input type="text" class="form-control" style="text-align: right;" v-model="base_value" id="base_value" placeholder="Enter Rate Percent" name="base_value" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{base_value_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Effective Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="effective_date" name="effective_date" v-model="effective_date" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="effective_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{effective_date_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateEffectiveCPIRateBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateEffectiveCPIRate" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateEffectiveCPIRateBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateEffectiveCPIRate" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueEffectiveCPIRateBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateEffectiveCPIRate(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelEffectiveCPIRateBtn" class="btn btn-tertiary" v-on:click.prevent="BackEffectiveCPIRateList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "EffectiveCPIRateCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Effective CPI Rate | " +process.env.COPYRIGHT_NAME : "Create Effective CPI Rate | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    permissions: [],
    cantAccessPage: "",
    cpi_code: null,
    cpicodeArr: [],
    base_value: "",
    effective_date: "",
    cpi_code_err_msg: "",
    base_value_error_msg: "",
    effective_date_error_msg: "",
    loading:false,
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_effective_cpi_rate') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadCPICode();
        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");
            
            if (segments[3]) {
                self.loadEffectiveCPIRate();
            }
        }, 100);
  },
  methods: {
    BackEffectiveCPIRateList() {
      var self = this;
      self.$router.push("/effectivecpirate/list");
    },

    loadCPICode() {
        
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/get-cpi-code",
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    
                    self.cpicodeArr = data.content;
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'effective-cpi-get-cpi')
            }
        });
    },

    CreateEffectiveCPIRate(flag) {
      var self = this;
      var error = false;

      self.effective_date_error_msg = "";
      self.base_value_error_msg = "";
      self.cpi_code_err_msg = "";

      if(self.cpi_code == null || !self.cpi_code.value) {
        self.cpi_code_err_msg = "CPI Code Required.";
        error = true; 
      }

      if (!self.base_value || self.base_value == null || self.base_value == "") {
        self.base_value_error_msg = "Base Value Required.";
        error = true;
      }

      if (!self.effective_date || self.effective_date == null || self.effective_date == "") {
        self.effective_date_error_msg = "Effective Date Required.";
        error = true;
      }
      
      if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateEffectiveCPIRateBtn").val("Updating ...");
                $("#CreateEffectiveCPIRateBtn").prop("disabled", true);
                $("#cancelEffectiveCPIRateBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueEffectiveCPIRateBtn").val("Saving ...");
                    $("#CreateEffectiveCPIRateBtn").prop("disabled", true);
                    $("#createAndContinueEffectiveCPIRateBtn").prop("disabled", true);
                    $("#cancelEffectiveCPIRateBtn").prop("disabled",true);

                }else{

                    $("#CreateEffectiveCPIRateBtn").val("Saving ...");
                    $("#CreateEffectiveCPIRateBtn").prop("disabled", true);
                    $("#createAndContinueEffectiveCPIRateBtn").prop("disabled", true);
                    $("#cancelEffectiveCPIRateBtn").prop("disabled",true);
                }
               
            }
            var fields = $("#EffectiveCPIRateForm").serializeArray();
            fields.push({name: "id", value: segments[3]});
            fields.push({name: "cpi_code", value: self.cpi_code.value});

            $.ajax({
                url: process.env.ROOT_API + "/effectivecpirate/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateEffectiveCPIRateBtn").val("Update");
                        $("#CreateEffectiveCPIRateBtn").prop("disabled", false);
                        $("#cancelEffectiveCPIRateBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueEffectiveCPIRateBtn").val("Save and Continue");
                            $("#CreateEffectiveCPIRateBtn").prop("disabled", false);
                            $("#createAndContinueEffectiveCPIRateBtn").prop("disabled", false);
                            $("#cancelEffectiveCPIRateBtn").prop("disabled",false);

                        }else{

                            $("#CreateEffectiveCPIRateBtn").val("Save");
                            $("#CreateEffectiveCPIRateBtn").prop("disabled", false);
                            $("#createAndContinueEffectiveCPIRateBtn").prop("disabled", false);
                            $("#cancelEffectiveCPIRateBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#EffectiveCPIRateForm").trigger("reset");
                            self.base_value = "";
                            self.effective_date = "";
                            self.cpi_code = null;
                    
                        }else{
                            self.$router.push("/effectivecpirate/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateEffectiveCPIRateBtn").val("Update");
                        $("#CreateEffectiveCPIRateBtn").prop("disabled", false);
                        $("#cancelEffectiveCPIRateBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#EffectiveCPIRateForm").trigger("reset");
                            

                            $("#createAndContinueEffectiveCPIRateBtn").val("Save and Continue");
                            $("#CreateEffectiveCPIRateBtn").prop("disabled", false);
                            $("#createAndContinueEffectiveCPIRateBtn").prop("disabled", false);
                            $("#cancelEffectiveCPIRateBtn").prop("disabled",false);

                        }else{

                            $("#CreateEffectiveCPIRateBtn").val("Save");
                            $("#CreateEffectiveCPIRateBtn").prop("disabled", false);
                            $("#createAndContinueEffectiveCPIRateBtn").prop("disabled", false);
                            $("#cancelEffectiveCPIRateBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'effective-cpi-create')
                }
            });
      }else{
            self.errorValidationFocus();
      }
     
    },

    loadEffectiveCPIRate() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/effectivecpirate/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    
                    self.effective_date = data.content.effective_date;
                    self.base_value = data.content.base_value;

                    if (data.content.cpi_code != null) {
                        self.cpi_code = {value: data.content.cpi_code, text: data.content.cpiName + " (" + data.content.cpiCode + ")"};
                    }else{
                        self.cpi_code = null;
                    }
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'effective-cpi-load-by-id')
            }
        });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/EffectiveCPIRateCreate.vue